// NOTE: /collections → /pages/select-box-type redirect is now handled
// via Shopify Admin 301 URL Redirect (Settings → Navigation → URL Redirects)

if (
  window.location.pathname === "/collections" ||
  window.location.pathname === "/collections/" ||
  window.location.pathname === "/collections/shop-all"
) {
  window.location.href = "/pages/select-box-type";
}

document.addEventListener("change", function (event) {
  if (event.target.matches(".block_subscription-options input[type=radio]")) {
    const radio = event.target;

    if (radio.checked && radio.value === "subscribe") {
      const subscribeOpt = radio.closest(".card-wrapper");
      const select = subscribeOpt.querySelector(
        ".block_product-subscribe_drawer select",
      );
      const getInputVal = select ? select.value : null;

      const infoCard = radio.closest(".card-wrapper");
      const subscriptionVal = infoCard.querySelector(
        ".block__product-card-subscription-val",
      );
      if (subscriptionVal) {
        subscriptionVal.value = getInputVal;
      }

      select.removeEventListener("change", handleSelectChange);
      select.addEventListener("change", handleSelectChange);

      function handleSelectChange() {
        const selectedValue = select.value;
        if (subscriptionVal) {
          subscriptionVal.value = selectedValue;
        }
      }
    } else {
      const getInputVal = radio.value;
      const infoCard = radio.closest(".card-wrapper");
      const subscriptionVal = infoCard.querySelector(
        ".block__product-card-subscription-val",
      );
      if (subscriptionVal) {
        subscriptionVal.value = getInputVal;
      }
    }
    radio
      .closest(".card-wrapper")
      .querySelector("#quantity")
      .setAttribute("value", 1);
  }
});
//==================  subscribe_opt change price ======================= //

document
  .querySelectorAll(".block_product-subscribe_opt input[type=radio]")
  .forEach(function (radio) {
    radio.addEventListener("click", function () {
      const priceElement = this.closest(
        ".block_product-subscribe_opt",
      ).querySelector(".block_product-grid_subscribe-price");
      const getPrice = priceElement
        ? priceElement.getAttribute("data-price")
        : null;

      const infoCard = this.closest(".card-wrapper");
      const buttonPrice = infoCard.querySelector(
        ".quick-add__submit .button-price",
      );

      if (buttonPrice) {
        buttonPrice.textContent = getPrice;
      }
    });
  });

// ========================  Card product quantity plus and minus ===================== //
document.addEventListener("DOMContentLoaded", function () {
  var Shopify = Shopify || {};
  // ---------------------------------------------------------------------------
  // Money format handler
  // ---------------------------------------------------------------------------
  Shopify.money_format = "${{amount}}";
  Shopify.formatMoney = function (cents, format) {
    if (typeof cents == "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || this.money_format;

    function defaultOption(opt, def) {
      return typeof opt == "undefined" ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ",");
      decimal = defaultOption(decimal, ".");

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split("."),
        dollars = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands,
        ),
        cents = parts[1] ? decimal + parts[1] : "";

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };

  document.querySelectorAll(".card-wrapper").forEach((card) => {
    const priceDisplay = card.querySelector(".button-price");
    if (!priceDisplay) {
      return; // Skip this card if the elements are missing
    }

    const basePriceCents =
      parseFloat(priceDisplay.textContent.replace(/[^0-9.-]+/g, "")) * 100;
    const quantityInput = card.querySelector(".quantity");
    const quantityInputbox = card.querySelector(".quantity_box");

    card.querySelectorAll("product-form [name='plus']").forEach((button) => {
      button.addEventListener("click", function () {
        let currentQuantity = parseInt(quantityInput.value);
        console.log("currentQuantity before increment:", currentQuantity);
        quantityInput.value = currentQuantity + 1;
        if (quantityInputbox) {
          quantityInputbox.value = currentQuantity + 1;
        }
        console.log("quantityInput", quantityInput.value);
        updatePrice();
      });
    });

    card.querySelectorAll("product-form [name='minus']").forEach((button) => {
      button.addEventListener("click", function () {
        let currentQuantity = parseInt(quantityInput.value);
        if (currentQuantity > 1) {
          quantityInput.value = currentQuantity - 1;
          if (quantityInputbox) {
            quantityInputbox.value = currentQuantity - 1;
          }
          updatePrice();
        }
      });
    });

    function updatePrice() {
      let quantity = parseInt(quantityInput.value);
      let totalPriceCents = basePriceCents * quantity;
      priceDisplay.textContent = Shopify.formatMoney(totalPriceCents);
    }
  });
  document.addEventListener("click", function (event) {
    const target = event.target.closest(
      ".rebuy-button, .rebuy-button span, .rebuy-product-actions",
    );

    if (target) {
      const widgetContainer = target.closest(".rebuy-widget-container");
      const interval = setInterval(doStuff, 100);

      function doStuff() {
        if (!widgetContainer.querySelector(".rebuy-button.working")) {
          clearInterval(interval);
          setTimeout(function () {
            updateCart();
          }, 100);
        }
      }
    }
  });

  const nextbtn = document.querySelector(".swiper-button-next");
  const prevbtn = document.querySelector(".swiper-button-prev");
  let slides = document.querySelectorAll(".swiper-slide");
  function checkSlides() {
    if (slides.length <= 3) {
      if (document.querySelector(".swiper-button-next")) {
        nextbtn.style.display = "none";
      }
      if (document.querySelector(".swiper-button-prev")) {
        prevbtn.style.display = "none";
      }
    } else {
      if (document.querySelector(".swiper-button-next")) {
        nextbtn.style.display = "";
      }
      if (document.querySelector(".swiper-button-prev")) {
        prevbtn.style.display = "";
      }
    }
  }

  checkSlides();

  var resizeTimer;
  window.addEventListener("resize", function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(checkSlides, 150);
  });

  function addActiveClassGlobal(event) {
    const parent = event.target.parentElement;
    Array.from(parent.children).forEach((child) => {
      child.classList.remove("active");
    });
    event.target.classList.add("active");
  }

  // start account page js
  document
    .querySelectorAll(".block_order-mange-order")
    .forEach((openOrderTab) => {
      openOrderTab.addEventListener("click", OnClickOpenOrderTab);
    });

  function OnClickOpenOrderTab(event) {
    var __this = event.currentTarget;
    __this
      .closest(".block_customers-order-info")
      .querySelector(".block_customers-order-info-bottom")
      .classList.toggle("active");
    __this
      .closest(".block_customers-order-info-top-right")
      .querySelector(".block_order-mange-order")
      .classList.toggle("active");
  }
  document.addEventListener("click", function (event) {
    var link = event.target.closest('a[href*="#"]');
    if (link && link.hash) {
      var target = document.querySelector(link.hash);
      if (target) {
        event.preventDefault();
        var topOffset = target.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
          top: topOffset,
          behavior: "smooth",
        });
        history.pushState(null, null, link.hash);
      }
    }
  });
  if (window.screen.width < 1091) {
    document
      .querySelectorAll(".block__account-menu-list")
      .forEach((openAccountTab) => {
        openAccountTab.addEventListener("click", OnClickOpenAccountTitleTab);
      });

    function OnClickOpenAccountTitleTab(event) {
      var __this = event.currentTarget;
      __this
        .closest(".block__customer-account-titles")
        .querySelector(".block__menu-list-wrapper")
        .classList.toggle("active");
      __this
        .closest(".block__customer-account-titles")
        .querySelector(".block__account-menu-list")
        .classList.toggle("border");
    }
  }
  document.querySelectorAll(".block__status-btn").forEach((view_address) => {
    view_address.addEventListener("click", OnClickViewmoreAdresses);
  });

  function OnClickViewmoreAdresses(event) {
    var __this = event.currentTarget;
    (__this.innerText == "View Status"
      ? (__this.innerText = "Hide Status")
      : (__this.innerText = "View Status"),
      __this
        .closest(".block__order-items-detail")
        .querySelector(".block__order-selling-plan")
        .classList.toggle("show"));
  }

  // ===========  Recharge Bundle Code Start ============= //
  // Only run on pages that actually have the build-a-box section
  if (
    document.querySelector("#build-a-box") ||
    document.querySelector(".block__upcharge-text-add")
  ) {
    // === Add eye === //
    const initializeObserver = () => {
      const targetNode = document.querySelector("#build-a-box");
      if (!targetNode) {
        return setTimeout(initializeObserver, 500);
      }
      const observer = new MutationObserver((mutations) => {
        mutations.forEach(({ addedNodes }) => {
          if (addedNodes.length > 0) {
            document
              .querySelectorAll(".rb-item-img .rb-img")
              .forEach((imgElement) => {
                if (!imgElement.querySelector(".product_cart_view")) {
                  imgElement.insertAdjacentHTML(
                    "beforeend",
                    `
                                    <svg width="40" class="product_cart_view" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 40px;position: absolute;top: auto;bottom: 20px;right: 20px;">
                                        <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" fill="white" stroke="#E4E4E2"></rect>
                                        <path d="M20 18C19.4706 18.0035 18.964 18.2153 18.5896 18.5896C18.2153 18.964 18.0035 19.4706 18 20C18 21.0947 18.9053 22 20 22C21.094 22 22 21.0947 22 20C22 18.906 21.094 18 20 18Z" fill="black"></path>
                                        <path d="M20.0005 15.3333C14.9119 15.3333 13.3825 19.7447 13.3685 19.7893L13.2979 20L13.3679 20.2107C13.3825 20.2553 14.9119 24.6667 20.0005 24.6667C25.0892 24.6667 26.6185 20.2553 26.6325 20.2107L26.7032 20L26.6332 19.7893C26.6185 19.7447 25.0892 15.3333 20.0005 15.3333ZM20.0005 23.3333C16.4332 23.3333 15.0512 20.7693 14.7165 20C15.0525 19.228 16.4352 16.6667 20.0005 16.6667C23.5679 16.6667 24.9499 19.2307 25.2845 20C24.9485 20.772 23.5659 23.3333 20.0005 23.3333Z" fill="black"></path>
                                    </svg>
                                `,
                  );
                }
              });
          }
        });
      });

      observer.observe(targetNode, { childList: true, subtree: true });
    };
    initializeObserver();
    // ==== add dynamic text add and new section create ====== //
    const observer = new MutationObserver(() => {
      const checkTitle = setInterval(() => {
        const tlhTitleElement = document.querySelector(
          "#build-a-box .tlh-title",
        );
        const rbHeader = document.querySelector(
          "#build-a-box .rb-container .rb-step-header .rb-step-title",
        );

        if (tlhTitleElement && rbHeader) {
          const titleText = tlhTitleElement.innerText;
          const numberMatch = titleText.match(/\d+/);
          const totalItems = numberMatch ? parseInt(numberMatch[0], 10) : 0;

          const previousLabel = rbHeader.querySelector(".block__choose_label");
          if (previousLabel) {
            rbHeader.removeChild(previousLabel);
          }
          const data_note_text = document
            .querySelector(".block__upcharge-text-add")
            .getAttribute("data_note_text");
          const label = document.createElement("div");
          label.className = "block__choose_label";
          label.style.cssText = "background-color: #fff; padding: 5px 0 0;";
          label.innerHTML = `<label class="medium_body">${data_note_text}</label><h5>${tlhTitleElement.innerText}</h5>`;
          rbHeader.appendChild(label);
          clearInterval(checkTitle);
        }
      }, 100);
      observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    // === Add Metafield content and viewall button === //
    fetch("/pages/about-us?view=all_product_get.json")
      .then((response) =>
        response.ok ? response.json() : Promise.reject("Failed to load"),
      )
      .then((data) => {
        if (data.products && Array.isArray(data.products)) {
          data.products.forEach((product) => {
            const { title, url, metafield } = product;

            const createAddToCartBtnAddon = () => {
              const targetNode = document.getElementById("build-a-box");

              if (!targetNode) {
                return setTimeout(createAddToCartBtnAddon, 500); // Retry if #build-a-box isn't found
              }

              const config = { childList: true, subtree: true };
              const observer = new MutationObserver(() => {
                //console.log("DOM Changes Detected - Updating Elements...");

                // **1️⃣ Add Metafield Portions Only If Title Matches**
                setTimeout(() => {
                  const productTitles = document.querySelectorAll(
                    "#build-a-box .rb-item .rb-title",
                  );

                  productTitles.forEach((titleElement) => {
                    const elementTitle = titleElement.textContent.trim();

                    if (elementTitle === title) {
                      // ✅ Match Title Before Adding
                      //console.log("Matching title found:", elementTitle);

                      if (!titleElement.querySelector(".block__portions")) {
                        const label = document.createElement("span");
                        label.className = "block__portions";
                        label.style.cssText =
                          "color: #808189;padding: 5px 0px 0;width: 100%;display: block;font-weight: 400;";
                        label.innerHTML = metafield.portions; // Fallback if portions are missing
                        titleElement.appendChild(label);
                      }
                    }
                  });
                }, 500); // Small delay to ensure elements exist

                // **2️⃣ Add "Show More" Button to Modal Only If Title Matches**
                const productImages = document.querySelectorAll(".rb-item-img");

                if (productImages.length > 0) {
                  productImages.forEach((item) => {
                    item.addEventListener("click", function (e) {
                      e.preventDefault();
                      const modalTitle =
                        document.querySelector(".rb-modal-title");

                      if (
                        modalTitle &&
                        modalTitle.textContent.trim() === title
                      ) {
                        // ✅ Match Title Before Adding Button
                        if (!document.querySelector(".view-all-button")) {
                          const viewAllButton =
                            document.createElement("button");
                          viewAllButton.textContent = "Show More";
                          viewAllButton.classList.add(
                            "view-all-button",
                            "button-primary",
                          );

                          const viewAllLink = document.createElement("a");
                          viewAllLink.href = url;
                          viewAllLink.appendChild(viewAllButton);

                          // Add Quick Description
                          const metafieldParagraph =
                            document.createElement("span");
                          const metafieldSpan = document.createElement("p");
                          metafieldSpan.textContent =
                            metafield.quick_product_description ||
                            "No description available";
                          metafieldParagraph.appendChild(metafieldSpan);

                          // Append elements to modal
                          const modalDescription = document.querySelector(
                            ".rb-modal-description",
                          );
                          if (modalDescription) {
                            modalDescription.appendChild(metafieldParagraph);
                            modalDescription.appendChild(viewAllLink);
                          }
                        }
                      }
                    });
                  });
                }
              });

              observer.observe(targetNode, config);
            };

            createAddToCartBtnAddon();
          });
        }
      })
      .catch((error) => console.error("Error fetching data:", error));

    // === add on page remove Plus icon and  Set add to cart === //
    const create_addtocart_btn_addon = () => {
      const get_cart_text = document.querySelector(".block__upcharge-text-add");
      const data_addto_cart = get_cart_text
        ? get_cart_text.getAttribute("data_addto_cart")
        : null;

      if (data_addto_cart) {
        const checkPlusClickInterval = setInterval(() => {
          const plus_click_items = document.querySelectorAll(
            ".rb-extras-wrapper .rb-btn-qty-plus span.tw1",
          );

          if (plus_click_items.length > 0) {
            clearInterval(checkPlusClickInterval);

            plus_click_items.forEach((item) => {
              item.innerText = `${data_addto_cart}`;
              item.addEventListener("click", function () {
                setTimeout(function () {
                  const rbExtrasSummaryButton = document.querySelector(
                    ".rb-extras-summary .rb-btn",
                  );
                  if (rbExtrasSummaryButton) {
                    rbExtrasSummaryButton.classList.add("active"); // Correct method usage

                    const proceedToCartLink = document.querySelector(
                      ".rb-extras-sidebar a.rb-link",
                    );
                    if (proceedToCartLink) {
                      proceedToCartLink.classList.add("hidden"); // Correct method usage
                    } else {
                      console.error("rb-extras-sidebar a.rb-link not found!");
                    }
                  } else {
                    console.error("rb-extras-summary .rb-btn not found!");
                  }
                }, 100);
              });
            });
          }
        }, 100);
      }
    };
    setTimeout(create_addtocart_btn_addon, 100);
  } // end build-a-box check
  // ===========  Recharge Bundle Code end ============= //
});
